import { createCdnIcon } from 'src/designSystem/CdnIcon';
import { createLocalIcon } from 'src/designSystem/LocalIcon';
import CheckFlatSvg from 'src/assets/onboarding/check-flat.svg?react';
import CloseSvg from 'src/assets/onboarding/close.svg?react';
import PhotoSvg from 'src/assets/onboarding/photo.svg?react';
import ShareSvg from 'src/assets/onboarding/share.svg?react';

export const ArrowRightIcon = createCdnIcon('arrow-right.svg');
export const BabzIcon = createCdnIcon('babz.svg');
export const CheckIcon = createCdnIcon('check.svg');
export const CheckFlatIcon = createLocalIcon(CheckFlatSvg);
export const CloseIcon = createLocalIcon(CloseSvg);
export const PhotoIcon = createLocalIcon(PhotoSvg);
export const RefreshIcon = createCdnIcon('refresh.svg');
export const ShareIcon = createLocalIcon(ShareSvg);
